import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "default-arrow",
  "use": "default-arrow-usage",
  "viewBox": "0 0 28.6 50.2",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.6 50.2\" id=\"default-arrow\"><path d=\"M28.6 25.1l-25 25.1L0 46.6l21.6-21.5L0 3.6 3.6 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol